

module.exports = __webpack_require__.stylable.create(
    "EmptyState2812226567",
    {"classes":{"root":"EmptyState2812226567__root","text":"EmptyState2812226567__text"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "EmptyState2812226567",
    null
);
